module.exports = __webpack_public_path__ + "9df7b31a.jpg";